import React from 'react';
import { getImageSrc } from '../../../util';

type Props = {
  className?: string;
  style?: React.CSSProperties;
};

const ProductBannerVideo: React.FC<Props> = ({ className, style }) => {
  return (
    <div className="mt-10 lg:-mt-10 lg:-mr-20 md:mt-10 md:-mr-20 lg:col-span-3">
      <dl className="hidden md:grid md:grid-cols-2 gap-y-4 justify-items-center md:grid md:grid-cols-10 md:gap-6 xl:gap-10 md:grid-rows-10 grid-rows-min xl:items-center">
        <div className="flex-col my-auto row-start-1 col-start-1 col-span-1 md:col-span-4 md:col-start-7 md:row-start-1 md:row-span-4 justify-center">
          <div className="w-full md:w-full lg:w-full xl:w-full rounded-2xl shadow-lg md:shadow-2xl border-white xl:border-6 border-4 xl:ml-6">
            <picture className=" lazyload rounded-lg object-cover ">
              <source
                srcSet={getImageSrc('landing_tablet_v3.webp')}
                type="image/webp"
              />
              <source
                srcSet={getImageSrc('landing_tablet_v3.jpg')}
                type="image/jpeg"
              />
              <img
                className=" lazyload rounded-lg object-cover "
                style={{ height: 'auto', width: '100%' }}
                data-src={getImageSrc('landing_tablet_v3.webp')}
                alt="App screenshot"
              />
            </picture>
          </div>
        </div>

        <div className=" inline-flex items-start md:flex-col  justify-items-center row-start-2 col-start-1 col-span-2  md:col-span-2 md:row-span-4 md:col-start-5 md:row-start-1  ">
          <div className="w-1/2  md:w-full lg:w-full xl:w-full md:mx-auto rounded-2xl xl:ml-0 shadow-lg md:shadow-2xl border-white xl:border-6 border-4 justify-center">
            <picture className=" lazyload rounded-lg object-cover ">
              <source
                srcSet={getImageSrc('card_front_dark.webp')}
                type="image/webp"
              />
              <source
                srcSet={getImageSrc('card_front_dark.png')}
                type="image/png"
              />
              <img
                className=" lazyload rounded-lg object-cover "
                style={{ height: 'auto', width: '100%' }}
                data-src={getImageSrc('card_front_dark.webp')}
                alt="App screenshot"
              />
            </picture>
          </div>
          <div className="w-1/2 md:mt-6 lg:mt-6 sm:w-1/2  md:w-full lg:w-full xl:w-full mx-auto xl:ml-0  rounded-2xl shadow-lg md:shadow-2xl border-white xl:border-6 border-4 justify-center">
            <picture className=" lazyload rounded-lg object-cover ">
              <source
                srcSet={getImageSrc('card_back_dark.webp')}
                type="image/webp"
              />
              <source
                srcSet={getImageSrc('card_back_dark.png')}
                type="image/png"
              />
              <img
                className=" lazyload rounded-lg object-cover "
                style={{ height: 'auto', width: '100%' }}
                data-src={getImageSrc('card_back_dark.webp')}
                alt="App screenshot"
              />
            </picture>
          </div>
        </div>

        <div className="flex-col col-span-1 row-start-1 col-start-2 md:col-span-4 md:col-start-1 md:row-start-2 lg:row-start-2 md:row-span-6 justify-center ">
          <div className=" w-3/4 md:w-2/3 lg:w-2/3 xl:w-3/4  mx-auto xl:mr-0 lg:mr-0 md:mr-0 rounded-xl shadow-lg md:shadow-2xl border-white xl:border-6 border-4 ">
            <picture className=" lazyload rounded-lg object-cover ">
              <source
                srcSet={getImageSrc('cassava_menu_v2.webp')}
                type="image/webp"
              />
              <source
                srcSet={getImageSrc('cassava_menu_v2.jpg')}
                type="image/jpeg"
              />
              <img
                className=" lazyload rounded-lg object-cover "
                style={{ height: 'auto', width: '100%' }}
                data-src={getImageSrc('cassava_menu_v2.webp')}
                alt="App screenshot"
              />
            </picture>
          </div>
        </div>

        <div className="flex row-start-3 col-start-1 col-span-2 md:col-span-7 md:col-start-5 md:row-start-5 md:row-span-5 items-end ">
          <div className="shadow-lg md:shadow-2xl border-white xl:border-6 border-4 rounded-2xl">
            <picture className=" lazyload rounded-lg object-cover ">
              <source
                srcSet={getImageSrc('Dashboard_v2.webp')}
                type="image/webp"
              />
              <source
                srcSet={getImageSrc('Dashboard_v2.jpg')}
                type="image/jpeg"
              />
              <img
                className=" lazyload rounded-lg object-cover "
                style={{ height: 'auto', width: '100%' }}
                data-src={getImageSrc('Dashboard_v2.webp')}
                alt="App screenshot"
              />
            </picture>
          </div>
        </div>
      </dl>
    </div>
  );
};

export default ProductBannerVideo;
